import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const EligibilityFileJobLogEntrySchema = withDefaults({
  'type': 'eligibility-file-job-log-entry',
  'fields': [
    {
      'kind': 'attribute',
      'name': 'eligibilityFileJobLogId'
    },
    {
      'kind': 'attribute',
      'name': 'logLevel'
    },
    {
      'kind': 'attribute',
      'name': 'key'
    },
    {
      'kind': 'attribute',
      'name': 'message'
    },
    {
      'kind': 'attribute',
      'name': 'data'
    },
    {
      'kind': 'belongsTo',
      'name': 'eligibilityFileJobLog',
      'type': 'eligibility-file-job-log',
      'options': {
        'async': false,
        'inverse': 'eligibilityFileJobLogEntries'
      }
    }
  ]
});

export default EligibilityFileJobLogEntrySchema;
